import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FaqWidgetService {
  private readonly isOpenSubject = new BehaviorSubject<boolean>(false);

  public readonly isOpen$: Observable<boolean> = this.isOpenSubject.asObservable();

  public open(): void {
    this.isOpenSubject.next(true);
  }

  public close(): void {
    this.isOpenSubject.next(false);
  }

  public get isOpen(): boolean {
    return this.isOpenSubject.value;
  }
}
